<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">      
		  <el-form-item style="width:12%" v-if="typelists.length > 1">
      		  <el-select v-model="query.type" filterable @change="ischange=true" clearable>
	              <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
      	  </el-form-item>

          <el-form-item style="width:15%">
              <el-select v-model="query.provinceid" filterable clearable placeholder="请选择省份" @change="ischange=true">	          
                  <el-option v-for="(item,index) in provincelists" :label="item.showname" :value="item.id" :key="index">
                      <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                      <span style="float: left">{{item.name}}</span>
                  </el-option>
              </el-select>
          </el-form-item>

          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getfreelists">查询</el-button>
              <el-button type="danger" icon="el-icon-plus" @click="add">新增免邮模板</el-button>
          </el-form-item>   
      </el-form>

      <el-tag type="danger" style="margin-top:10px">温馨提示：该功能为分销商品下单时使用，暂不适用于线上商城，因线上商城有起送金额</el-tag>
      
      <div class="backborder2" style="margin-top:10px">
			<el-table :data="freelists" v-loading="loading">
		        <el-table-column prop="name" label="名称"></el-table-column>
                <!--
                <el-table-column prop="typename" label="数据类型" width="160" align="center" v-if="typelists.length > 1"></el-table-column>
		        -->
                <el-table-column prop="provincenames" label="包邮省份" width="180"></el-table-column>
		        <el-table-column prop="inputtime" label="添加时间" width="180" align="center"></el-table-column>
		        <el-table-column prop="price" label="订单起步金额" width="180" align="center"></el-table-column>
		        <el-table-column label="操作" width="120" align="center">
			        <template slot-scope="scope">
			            <el-button type="warning" size="small" icon="el-icon-edit" circle @click="edit(scope.row)"></el-button>
                        <el-button type="danger" size="small" icon="el-icon-delete" circle @click="del(scope.row)"></el-button>
			        </template>
		        </el-table-column>
	        </el-table>

	        <div class="block">
		        <!--分页begin-->
		        <el-pagination
		            @size-change="pageProductSizeChange"
		            @current-change="pageProductCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_rows">
		        </el-pagination>
		        <!--分页end-->
	        </div>
      </div>

      <!-- 新增免邮模板 -->
      <el-dialog title="新增免邮模板" :visible.sync="addDialog" width="25%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">   
                <el-form-item label="模板名称" style="width:100%">
                    <el-input placeholder="模板名称" v-model="addquery.name" style="width:100%"></el-input>
                </el-form-item>      
                <!--
                <el-form-item label="商品类型" style="width:100%" v-if="typelists.length > 1">
                    <el-select v-model="addquery.type" filterable style="width:100%">
                        <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                -->
                <el-form-item label="所在省份" style="width:100%">
                    <el-select v-model="addquery.provinceid" filterable clearable placeholder="请选择省份" style="width:100%" multiple>	          
                        <el-option v-for="(item,index) in provincelists" :label="item.showname" :value="item.id" :key="index">
                            <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                            <span style="float: left">{{item.name}}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="起始金额" style="width:100%">
                    <el-input placeholder="金额" v-model="addquery.price" style="width:100%"></el-input>
                </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="addDialog = false">取 消</el-button>
              <el-button size="medium" type="primary" @click="savetemp">保 存</el-button>
          </div>
      </el-dialog>

      <!-- 编辑免邮模板 -->
      <el-dialog title="新增免邮模板" :visible.sync="updateDialog" width="25%" top="10vh">
          <el-form :inline="true" class="demo-form-inline" size="small">   
                <el-form-item label="模板名称" style="width:100%">
                    <el-input placeholder="模板名称" v-model="updatequery.name" style="width:100%"></el-input>
                </el-form-item>      
                <!--
                <el-form-item label="商品类型" style="width:100%" v-if="typelists.length > 1">
                    <el-select v-model="updatequery.type" filterable style="width:100%" disabled>
                        <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                -->
                <el-form-item label="所在省份" style="width:100%">
                    <el-select v-model="updatequery.provinceid" filterable clearable placeholder="请选择省份" style="width:100%" multiple>	          
                        <el-option v-for="(item,index) in provincelists" :label="item.showname" :value="item.id" :key="index">
                            <span style="float: left;margin-right:10%;font-size: 13px">{{item.py}}</span>
                            <span style="float: left">{{item.name}}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="起始金额" style="width:100%">
                    <el-input placeholder="金额" v-model="updatequery.price" style="width:100%"></el-input>
                </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="updateDialog = false">取 消</el-button>
              <el-button size="medium" type="primary" @click="updatetemp">保 存</el-button>
          </div>
      </el-dialog>


  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Freetemp/index",
      transitionshow:true,
      loading:false,
      query: {
          act:'lists',
		  token:this.$cookies.get('token'),
          type:'',
          provinceid:'',
          p:1,
          rollpage:10
      },
      freelists:[],
      total_rows:0,
      isjdshow:0,
      typelists:[{id:1,name:'宠赞'}],
      provincelists:[],
      addDialog:false,
      addquery: {
          act:'addtemp',
		  token:this.$cookies.get('token'),
          name:'',
          type:2,
          provinceid:'',
          price:'',
          provinces:[],
      },
      updateDialog:false,
      updatequery: {
          act:'updatetemp',
		  token:this.$cookies.get('token'),
          id:'',
          name:'',
          type:'',
          provinceid:'',
          price:'',
          provinces:[],
      },
      
    }  
  },
  mounted(){
      this.getJDshow(); //查询是否开启调用京东数据权限
      this.getProvince(); //查询省份信息
      this.getfreelists(); //获取免邮模板信息
  },
  methods:{

      /** 获取免邮模板信息 **/
      getfreelists() {
          if(this.ischange==true) {
              this.query.p=1;
              this.query.rollpage=10;
          }
          
          this.loading=true;
          var resource = this.$resource(this.url);
	      resource.query(this.query).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
                  this.loading=false;
		      }else{
		          this.freelists = JSON.parse(Base64.decode(res.data.Data));
		          this.total_rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.loading=false;
		      }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
              this.loading=false;
	      });
      },

      pageProductSizeChange(val) {
          this.query.rollpage = val;
          this.getfreelists();
      },
      pageProductCurrentChange(val) {
          this.query.p = val;
          this.getfreelists();
      },

      //新增免邮模板
      add() {
          //this.addquery.type='';
          this.addquery.provinceid='';
          this.addquery.name='';
          this.addquery.price='';
          this.addDialog=true;
      },

      //查询是否开启调用京东商品数据权限
	  getJDshow() {
		  var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
	      resource.query({act:'getJDshow',token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		      }else{
		          var result = JSON.parse(Base64.decode(res.data.Data));
		          this.isjdshow=result.show;
                  if(this.isjdshow==true) this.typelists.push({id:2,name:'京东'});
		      }
	      }).catch((res) => {
	          this.$message.error(this.GLOBAL.errortext);
	      });
	  },

      /** 获取京东省份信息 **/
      getProvince() {
          this.addressloading=true;
          var resource = this.$resource(this.GLOBAL.domain+"Product/index");	
          resource.query({act:'getjdaddressinfos',type:1,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.provincelists = JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              	
          });
      },

      /** 保存新增包邮模板 **/
      savetemp() {
          //搜集地址信息
          var _this=this;
          this.addquery.provinces=[];
          this.provincelists.forEach(function(item,i) {
              _this.addquery.provinceid.indexOf(item.id) > -1 ?  _this.addquery.provinces.push({id:item.id,name:item.name}) : "";
          });

          this.addressloading=true;
          var resource = this.$resource(this.url);	
          resource.save(this.addquery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.$message.success('添加免邮模板信息成功！');
                  this.getfreelists();
                  this.addDialog=false;
              }
          }).catch((res) => {
              	
          });
      },

      /** 删除当前包邮模板信息 **/
      del(item) {
            this.$confirm('您是否确定要删除该包邮模板信息 ?', '提示', { type: 'warning' }).then(() => {
        	    var resource = this.$resource(this.url);	
                resource.query({act:'deltemp',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                        if(res.data.Result=='70001') this.$router.push('/login')
                        this.$message.error(res.data.Message);
                    }else{
                        this.getfreelists();
                    }
                }).catch((res) => {
                        
                });
            }).catch(() => {
                
            });
      },


      /** 获取免邮模板信息 **/
      edit(item) {
          this.updatequery.id='';
          this.updatequery.name='';
          this.updatequery.type='';
          this.updatequery.provinceid=[];
          this.updatequery.price='';
          this.updatequery.provinces=[];
          this.updateDialog=true;

          var resource = this.$resource(this.url);	
          resource.query({act:'gettempinfo',id:item.id,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  var _this=this;
                  var number='';
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  this.updatequery.id=result.id;
                  this.updatequery.name=result.name;
                  this.updatequery.type=Number(result.type);
                  result.provinceid.forEach(function(t,i) {
                      number=Number(t);
                      _this.updatequery.provinceid.push(number);
                  })
                  this.updatequery.price=result.price;
                  this.updatequery.provinces=result.provinces;
              }
          }).catch((res) => {
                        
          });
      },

      /** 保存修改的免邮模板信息 **/
      updatetemp() {
          //搜集地址信息
          var _this=this;
          this.updatequery.provinces=[];
          this.provincelists.forEach(function(item,i) {
              _this.updatequery.provinceid.indexOf(item.id) > -1 ?  _this.updatequery.provinces.push({id:item.id,name:item.name}) : "";
          });

          var resource = this.$resource(this.url);	
          resource.save(this.updatequery).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.updateDialog=false;
                  this.getfreelists();
              }
          }).catch((res) => {
                        
          });
      },

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/Freetemp.vue